import { render, staticRenderFns } from "./DrawerSubscriptionWhitelist.vue?vue&type=template&id=b50806ea&scoped=true&"
import script from "./DrawerSubscriptionWhitelist.vue?vue&type=script&lang=js&"
export * from "./DrawerSubscriptionWhitelist.vue?vue&type=script&lang=js&"
import style0 from "./DrawerSubscriptionWhitelist.vue?vue&type=style&index=0&id=b50806ea&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50806ea",
  null
  
)

export default component.exports